import { Pipe, PipeTransform } from '@angular/core';

// NOTE: try to handle this with css

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  public transform(value: string, length: number): string {
    const ellipsis = '...';
    let result = value;
    if (value.length > length) {
      result = `${value.slice(0, length)}${ellipsis}`;
    }
    return result;
  }
}
